import { AspectRatio, MediaAsset } from 'libs/contentful/types';
import { cn, getColorway } from 'utils/styles';
import RichTextCopy from 'components/shared/RichTextCopy/RichTextCopy';
import Media from 'components/shared/Media/Media';
import { SharedBentoBoxCardProps } from 'types/sharedComponents';
import { liveUpdateAttrs } from 'libs/contentful/utils';
import { BentoBoxCardHeadlineSize, BentoBoxLayout } from 'types/constants';

interface Props extends SharedBentoBoxCardProps {
  headlineSize?: BentoBoxCardHeadlineSize;
  icon: MediaAsset;
  aspectRatio?: AspectRatio;
  layout?: BentoBoxLayout;
  classNames?: string;
}

const BentoBoxIconCard = ({
  sys,
  color,
  cardHeadlineRte,
  headlineSize,
  copy,
  icon,
  aspectRatio,
  layout,
  classNames,
}: Props) => {
  const isThreeByTwo = layout === BentoBoxLayout.ThreeByTwo;

  return (
    <div
      className={cn(
        'flex h-full rounded-lg p-6 col-span-2 sm:col-span-1',
        isThreeByTwo ? 'md:aspect-4/3' : 'sm:aspect-3/2 md:aspect-square',
        classNames,
        getColorway(color),
      )}>
      <div
        className={cn(
          isThreeByTwo
            ? 'flex flex-col justify-between items-start gap-8 sm:gap-0'
            : 'flex flex-row sm:flex-col sm:justify-between items-center sm:items-start gap-6 sm:gap-0',
        )}>
        <div
          className={isThreeByTwo ? 'w-12 h-12 md:w-18 md:h-18' : 'w-18 h-18 md:h-1/3 md:w-1/3'}
          {...liveUpdateAttrs(sys?.id, 'cardIcon')}>
          <Media
            className="rounded-none sm:w-100"
            media={{
              ...icon,
            }}
            sizes="100px" // Image is maximum of ~87px wide, so 100px is fine
            aspectRatio={aspectRatio}
          />
        </div>
        <div className={cn('flex flex-col', isThreeByTwo && 'gap-2')}>
          {cardHeadlineRte && (
            <div
              className={cn('font-sans font-semibold text-heading-sm', {
                'md:text-heading-md': headlineSize === BentoBoxCardHeadlineSize.Large,
              })}
              {...liveUpdateAttrs(sys?.id, 'cardHeadlineRte')}>
              <RichTextCopy copy={cardHeadlineRte} />
            </div>
          )}
          {copy && (
            <div className="font-sans font-medium" {...liveUpdateAttrs(sys?.id, 'cardCopy')}>
              <RichTextCopy copy={copy}></RichTextCopy>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BentoBoxIconCard;
